import React from "react";
import {PaymentMethod} from "../../../http/protocol";
import "./styles/PaymentProviderButton.scss";
import {t} from "../../../i18n";
import "../../../assets/payments/icons/payment-icons.css"

const ExpandButton = (props: {clicked: boolean}) => (
    <div className={props.clicked ? `${"rectangleContainer"} ${"clicked"}`: "rectangleContainer"}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21">
            <path fillRule="nonzero" d="M3.621 10.5l7.94-7.94A1.5 1.5 0 0 0 9.439.44l-9 9a1.5 1.5 0 0 0 0 2.12l9 9a1.5 1.5 0 0 0 2.122-2.12L3.62 10.5z"/>
        </svg>
    </div>
)

const ActiveItem = (props : {method : PaymentMethod, clicked: boolean, choose? : (m : PaymentMethod) => void }) => {
    return (
        <div className={`${"dropdownItem"} ${"active"}`}>
            {props.method.code &&
            <div className={`${"item"} ${"active"}`}>
                <div className={"left"}>
                    <img alt={"method icon"} className={"img method-"+props.method?.code?.toLowerCase()}/>
                    <div className={"text"}>
                        {t(`payments.method.${props.method.code}.name`, undefined, props.method.name)}
                    </div>
                </div>
                <div className={"right"}>
                    <ExpandButton clicked={props.clicked}/>
                </div>
            </div>
            }
        </div>
    )
}

export default ActiveItem;